import {Exir} from "../../ui";
import App from "./App";
import "./index.css";
import "./globalStore";

Exir.mount(App, document.getElementById('app'))